import script from "./ServiceAgreeForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceAgreeForm.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceAgreeForm.vue?vue&type=style&index=0&id=7b9d0318&scoped=true&lang=css"
import "./ServiceAgreeForm.vue?vue&type=style&index=1&id=7b9d0318&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b9d0318"]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QCheckbox,QBtn});
